import React from "react";
import TextArea from "devextreme-react/text-area";
import { IMdaeTextAreaProps } from "./index";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  configureMdaeWidgetOptionUpdaters,
  DX_WIDGET_NAMES,
  getNestedPropertyValue,
} from "../../mdae-framework";
import { RequiredFieldLabel } from "../required-field-label";

const MdaeTextArea: React.FC<IMdaeTextAreaProps> = (props) => {
  const dispatch = useDispatch();
  const valueUpdaterConfig = props.mdaeDataUpdaterConfig?.find((x) =>
    Boolean(x.widgetOptionBindings?.value)
  );
  const currentWidgetValue = useSelector((state: any) => {
    if (valueUpdaterConfig)
      return getNestedPropertyValue(
        valueUpdaterConfig.widgetOptionBindings.value,
        state[valueUpdaterConfig.reducerName]
      );
    else return "";
  });

  return (
    <div className={"sys-mdae-text-area-container"}>
      <TextArea
        {...props}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_TEXT_AREA,
            e.component,
            dispatch
          );
        }}
      />
      {props.visible !== false && (
      <span className={`mdae-text-box-field-set-text ${props.madeFieldTitleClassName}`}>
          {props.mdaeTextAreaTitle}
          {props.required && <RequiredFieldLabel />}
        </span>
      )}
      {props.showRemainingCharecters && (
        <div className="widget-footer-row">
          <span>
            {currentWidgetValue?.length ? currentWidgetValue.length : 0}/
            {props.maxLength}
          </span>
        </div>
      )}
    </div>
  );
};
export default MdaeTextArea;
